import MainMenu from 'components/nav/authenticated/mobile/MainMenu';
import AccountManageMenu from 'components/nav/authenticated/mobile/AccountManageMenu';
import PenNamesMenu from 'components/nav/authenticated/mobile/PenNamesMenu';
import LanguageMenu from 'components/nav/shared/LanguageMenu';

const menus = { default: MainMenu };

menus[MainMenu.menuName] = MainMenu;
menus[AccountManageMenu.menuName] = AccountManageMenu;
menus[PenNamesMenu.menuName] = PenNamesMenu;
menus[LanguageMenu.menuName] = LanguageMenu;

export default menus;
